module.exports = __webpack_public_path__ + "img/bra.87032851.svg";